//simple button with image and text interface
import React from "react";
import styles from "./UtilityButton.module.css";
import { useFont } from "../../contexts/FontContext/FontContext";

const UtilityButton = ({ id, imageId, title, option, imageSrc, onHover, onLeave, onClick, fadeClass, isDisabled, borderStyle }) => {
    const fontSchemes = useFont();    
    const fontFamilyOne = fontSchemes.scheme_one;

    return (
      <button className={`${styles.integration_buttons} ${fadeClass} ${id}`} onMouseEnter={() => onHover(option)} onMouseLeave={onLeave} onClick={() => onClick(option)} style={{ ...borderStyle, transition: "border 0.3s ease, box-shadow 0.3s ease" }} disabled={isDisabled}>
          <p className={`titles ${styles.integration_button_titles} ${fontFamilyOne}`}>{title}</p>
          <img src={imageSrc} className={`${styles.integration_button_images} ${imageId}`} alt={`${option} logo`} />
      </button>
    );
};

export default UtilityButton;